import React, { useState, useEffect } from 'react';
import styles from './index.module.css';
import logo from '../layout/assets/logo-contact.svg';
import {
  FaPhone,
  FaWhatsapp,
  FaFacebook,
  FaInstagram,
  FaTelegram,
  FaGlobe,
  FaYoutube,
} from 'react-icons/fa';
import { FaTiktok, FaLinkedinIn } from 'react-icons/fa6';
import { MdEmail } from 'react-icons/md';
import { GoShareAndroid } from 'react-icons/go';

const Contact = () => {
  const [floatingIcons, setFloatingIcons] = useState([]);

  useEffect(() => {
    const iconTypes = [
      { icon: <FaWhatsapp />, color: '#25D366' },
      { icon: <FaFacebook />, color: '#1877F2' },
      { icon: <FaInstagram />, color: '#E4405F' },
      { icon: <FaTelegram />, color: '#0088cc' },
      { icon: <FaLinkedinIn />, color: '#0077B5' },
      { icon: <FaTiktok />, color: '#000000' },
      { icon: <FaYoutube />, color: '#FF0000' },
      { icon: <MdEmail />, color: '#EA4335' },
      { icon: <FaGlobe />, color: '#00BCD4' },
    ];

    const generateFloatingIcons = () => {
      const numberOfIcons = 300; // Generate 100 floating icons
      const floatingIconsArray = [];

      for (let i = 0; i < numberOfIcons; i++) {
        const randomIcon =
          iconTypes[Math.floor(Math.random() * iconTypes.length)];

        // More randomized positions with better distribution
        const left = Math.random() * 120 - 10; // Can go slightly outside viewport (-10% to 110%)
        const top = Math.random() * 120 - 10; // Can go slightly outside viewport (-10% to 110%)

        // Random animation type for more variety
        const animationType = Math.floor(Math.random() * 4) + 1; // 1-4 different animation patterns

        floatingIconsArray.push({
          id: i,
          icon: randomIcon.icon,
          color: randomIcon.color,
          left: left,
          top: top,
          animationDuration: 5 + Math.random() * 10, // Random duration between 5-15s (faster)
          animationDelay: Math.random() * 5, // Random delay 0-5s
          size: 12 + Math.random() * 25, // Random size between 12-37px
          animationType: animationType, // Different animation patterns
          xOffset: (Math.random() - 0.5) * 100, // Random X movement range
          yOffset: (Math.random() - 0.5) * 100, // Random Y movement range
        });
      }

      return floatingIconsArray;
    };

    setFloatingIcons(generateFloatingIcons());
  }, []);

  const handleShare = async () => {
    const shareData = {
      title: 'Epinics - Contact Us',
      text: 'Get in touch with Epinics for your POS system needs',
      url: window.location.href,
    };

    try {
      // Check if Web Share API is supported
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        // Fallback: Copy to clipboard
        await navigator.clipboard.writeText(window.location.href);
        alert('Link copied to clipboard!');
      }
    } catch (error) {
      // User cancelled or error occurred
      if (error.name !== 'AbortError') {
        // Fallback: Copy to clipboard
        try {
          await navigator.clipboard.writeText(window.location.href);
          alert('Link copied to clipboard!');
        } catch (clipboardError) {
          console.error('Error sharing:', clipboardError);
        }
      }
    }
  };

  const contactLinks = [
    {
      id: 1,
      icon: <FaPhone />,
      text: 'Phone',
      link: 'tel:+94741041212',
      color: '#25D366',
    },
    {
      id: 2,
      icon: <FaWhatsapp />,
      text: 'WhatsApp',
      link: 'https://wa.me/94741041212',
      color: '#25D366',
    },
    {
      id: 7,
      icon: <MdEmail />,
      text: 'Email',
      link: 'mailto:info@epinics.com',
      color: '#EA4335',
    },
    {
      id: 8,
      icon: <FaGlobe />,
      text: 'Website',
      link: 'https://epinics.com',
      color: '#00BCD4',
    },
    {
      id: 3,
      icon: <FaFacebook />,
      text: 'Facebook',
      link: 'https://www.facebook.com/epinicspos',
      color: '#1877F2',
    },
    {
      id: 9,
      icon: <FaLinkedinIn />,
      text: 'LinkedIn',
      link: 'https://www.linkedin.com/company/epinics',
      color: '#0077B5',
    },
    {
      id: 4,
      icon: <FaTiktok />,
      text: 'TikTok',
      link: 'https://www.tiktok.com/@epinicspos0',
      color: '#000000',
    },
    {
      id: 10,
      icon: <FaYoutube />,
      text: 'YouTube',
      link: 'https://www.youtube.com/@EpinicsPOS',
      color: '#FF0000',
    },
    {
      id: 5,
      icon: <FaInstagram />,
      text: 'Instagram',
      link: 'https://www.instagram.com/epinics_pos',
      color: '#E4405F',
    },
    {
      id: 6,
      icon: <FaTelegram />,
      text: 'Telegram',
      link: 'https://t.me/+94741041212',
      color: '#0088cc',
    },
  ];

  return (
    <div className={styles.mainContainer}>
      <div className={styles.backgroundPattern}></div>
      <div className={styles.floatingIconsContainer}>
        {floatingIcons.map((item) => (
          <div
            key={item.id}
            className={`${styles.floatingIcon} ${
              styles[`animationType${item.animationType}`]
            }`}
            style={{
              left: `${item.left}%`,
              top: `${item.top}%`,
              color: item.color,
              fontSize: `${item.size}px`,
              animationDuration: `${item.animationDuration}s`,
              animationDelay: `${item.animationDelay}s`,
              '--x-offset': `${item.xOffset}px`,
              '--y-offset': `${item.yOffset}px`,
            }}
          >
            {item.icon}
          </div>
        ))}
      </div>
      <div className={styles.contentCard}>
        <button
          className={styles.shareButton}
          onClick={handleShare}
          aria-label="Share this page"
          title="Share this page"
        >
          <GoShareAndroid />
        </button>
        <div className={styles.logoContainer}>
          <img src={logo} alt="Epinics Logo" className={styles.logo} />
          <div className={styles.brandName}>EPINICS</div>
        </div>

        <div className={styles.description}>
          Get in touch with us. We're here to help you with your POS system
          needs.
        </div>

        <div className={styles.contactButtons}>
          {contactLinks.map((item) => (
            <a
              key={item.id}
              href={item.link}
              target={item.link.startsWith('http') ? '_blank' : undefined}
              rel={
                item.link.startsWith('http') ? 'noopener noreferrer' : undefined
              }
              className={styles.contactButton}
            >
              <div
                className={styles.iconContainer}
                style={{ backgroundColor: item.color }}
              >
                {item.icon}
              </div>
              <span className={styles.buttonText}>{item.text}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Contact;
